import { clearEventBuffer } from "src/core/analytics/dataMesh/utils/bufferMethods/clearEventBuffer";
import { getEventBuffer } from "src/core/analytics/dataMesh/utils/bufferMethods/getEventBuffer";
import { sendDataMeshEvent } from "src/core/analytics/dataMesh/utils/sendDataMeshEvent";
import { getDataMeshOldEventsCleanTime } from "src/core/analytics/imports/environment";
import { currentTimeMillis } from "src/core/analytics/imports/utils";

export const clearOldBufferEvents = async () => {
  const eventsBuffer = await getEventBuffer();

  if (eventsBuffer.length === 0) {
    return;
  }

  const lastEventTimestamp = eventsBuffer.at(-1)?.timestamp || 0;

  const isBufferTimeExpired =
    currentTimeMillis() - lastEventTimestamp >= getDataMeshOldEventsCleanTime();

  if (isBufferTimeExpired) {
    await clearEventBuffer();
  } else {
    sendDataMeshEvent(eventsBuffer, { isBufferFlushNeeded: true });
  }
};
